import { useState } from "react";

const useForm = (initialValues) => {
  // !--------------------------- States ---------------------------
  const [values, setValues] = useState(initialValues);
  const [imagePreviews, setImagePreviews] = useState({}); 

  // !--------------------------- Functions ---------------------------
  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;

    if (type === "file") {
      const file = files[0];
      setValues({
        ...values,
        [name]: file,
      });

      // Generate image preview if it's an image
      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreviews((prevPreviews) => ({
            ...prevPreviews,
            [name]: reader.result, 
          }));
        };
        reader.readAsDataURL(file);
      } else {
        setImagePreviews((prevPreviews) => ({
          ...prevPreviews,
          [name]: null,
        }));
      }
    } else if (type === "radio") {
      setValues({
        ...values,
        [name]: value === "true",
      });
    } else if (type === "checkbox") {
      setValues({
        ...values,
        [name]: checked,
      });
    } else {
      setValues({
        ...values,
        [name]: value,
      });
    }
  };

  const resetForm = () => {
    setValues(initialValues);
    setImagePreviews({}); 
  };

  return {
    values,
    setValues,
    handleChange,
    resetForm,
    imagePreviews, 
    setImagePreviews
  };
};

export default useForm;
